<template>
  <v-layout justify-center>
    <v-flex shrink>
      <v-btn @click="getSimilarItems" color="blue" dark :loading="loadingSimilarItems">
        <span class="pr-3">Aplicar filtros</span>
        <v-icon>send</v-icon>
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapActions, mapGetters, mapState } = createNamespacedHelpers(
  "matching"
);

export default {
  computed: {
    ...mapGetters(["pivotItem"]),
    ...mapState(["loadingSimilarItems"])
  },
  methods: {
    ...mapActions(["getSimilarItems"])
  }
};
</script>